




















import { detailedDate } from "@/lib/utility/date-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import PartnerReportRentalCard from "./rental/PartnerReportRentalCard.vue";
import PartnerReportSelectRentalCompanyCard from "./rental/PartnerReportSelectRentalCard.vue";
import RentalApprovalLimitsSheet from "./rental/RentalApprovalLimitsSheet.vue";

@Component({
  components: {
    PartnerReportRentalCard,
    PartnerReportSelectRentalCompanyCard,
    RentalApprovalLimitsSheet
  },
  filters: { detailedDate }
})
export default class PartnerReportDetailRental extends mixins(PermissionMixin) {
  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get report() {
    return PartnerModule.report;
  }
}
